module.exports = __webpack_public_path__ + "img/edit_magic_remove.6d2f6a4.png";